import { getParams } from '../atsReports/common/get-params';

type StaticReportData = {
  timeFrame: any;
  filters: any;
  filterParams: any;
  tableGroups: any;
};

export const getStaticReportData = (
  state,
  tableId = null,
  isCompare = false
): StaticReportData => {
  const { timeFrame, filters, tableGroups } = state.staticReports;
  const filterParams = getParams({
    timeFrame,
    group: tableId ? tableGroups[tableId] : undefined,
    filters,
    compare: isCompare,
  });

  return {
    timeFrame,
    filters,
    filterParams,
    tableGroups,
  };
};

export const selectChartType = (state: any, chartKey: string) => {
  return state.staticReports.chartTypes[chartKey];
};
